const $ = window.jQuery;

document.addEventListener('DOMContentLoaded', () => {
    $('.js-product-rating-form').validate({
        submitHandler: function(form) {
            $(form).find('[type="submit"]').addClass('is-loading');

            window.Form.ajaxPost(form, function(data) {
                $('.js-product-rating-message').slideUp(100);

                if (data.status) {
                    $('.js-product-rating-form').slideUp();
                }

                $('.js-product-rating-message')
                    .toggleClass('c-msg--error', !data.status)
                    .toggleClass('c-msg--success', data.status)
                    .text(data.message)
                    .slideDown();

                $(form).find('[type="submit"]').removeClass('is-loading');
            }, 'json');
        }
    });
})